import axios from "axios";

export const qwMonarch = axios.create({
  baseURL: process.env.QW_MONARCH_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
